const c = (r) => "#" + r.map((n) => {
  const e = n.toString(16);
  return e.length === 1 ? "0" + e : e;
}).join(""), g = (r) => `rgb(${r[0]}, ${r[1]}, ${r[2]})`, a = (r, t = 125) => {
  const n = r.replace(/^#/, ""), e = parseInt(n.substring(0, 2), 16), o = parseInt(n.substring(2, 4), 16), s = parseInt(n.substring(4, 6), 16);
  return [e, o, s, t];
}, i = (r) => {
  if (r.startsWith("rgb")) {
    const t = r.match(/\d+/g);
    if (!t || t.length < 3)
      throw new Error("Invalid CSS color format");
    return [parseInt(t[0]), parseInt(t[1]), parseInt(t[2])];
  } else {
    if (r.startsWith("#"))
      return a(r);
    throw new Error("Unsupported CSS color format");
  }
}, u = (r) => {
  const t = r.map((n) => {
    const e = n.toString(16);
    return e.length === 1 ? "0" + e : e;
  });
  return "#" + t[0] + t[1] + t[2];
}, h = (r) => `linear-gradient(180deg, ${[...r].reverse().map((n) => `rgb(${n.join(", ")})`).join(", ")})`;
export {
  i as cssColorToRgbArray,
  h as gradientColorConvert,
  a as hexToRGBA,
  g as rgbArrayCssColor,
  c as rgbArrayToHex,
  u as rgbToHex
};
//# sourceMappingURL=index.es277.js.map
